// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body,html,#root{width:100%;height:100%;margin:0;padding:0;overflow:auto}", "",{"version":3,"sources":["webpack://./src/stylesheets/base.scss"],"names":[],"mappings":"AAAA,gBAGE,UAAA,CACA,WAAA,CACA,QAAA,CACA,SAAA,CACA,aAAA","sourcesContent":["body,\nhtml,\n#root {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
